import ApiClient from './ApiClient';

class EditorFilesAPI extends ApiClient {
  constructor() {
    super('editor_files', { accountScoped: true });
  }
}

export default new EditorFilesAPI();
